export default __webpack_public_path__ + "static/media/sh.8ac44af5.svg";